import React, { useEffect, useState } from "react";
import { useStyles } from "../../assets/styles.js";
import Radio from "@material-ui/core/Radio";
import moment from "moment";
import RadioGroup from "@material-ui/core/RadioGroup";
import {
  Grid,
  Button,
  TextField,
  Select,
  Avatar,
  InputLabel,
  MenuItem,
  FormControl,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormLabel,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Ensure you have this icon imported
import { useNavigate } from "react-router-dom";
import { Colors } from "../../assets/styles.js";
import logo_icon from "../../assets/images/logo_icon.png";
import { InputAdornment, IconButton } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import * as AstrologerActions from "../../redux/Actions/astrologerActions.js";
import * as ExpertiesActions from "../../redux/Actions/expertiesActions.js";
import * as SkillActions from "../../redux/Actions/skillsActions.js";
import * as RemedyActions from "../../redux/Actions/remediesActions.js";
import * as SettingActions from "../../redux/Actions/settingActions.js";
import Loader from "../../Components/loading/Loader.js";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const preferredDaysList = [
  "Mon",
  "Tues",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
  "All",
];
const languages = [
  "Hindi",
  "English",
  "Assamese",
  "Bengali",
  "Bodo",
  "Dogri",
  "Gujarati",
  "Kannada",
  "Kashmiri",
  "Konkani",
  "Malayalam",
  "Meithei",
  "Marathi",
  "Nepali",
  "Oriya",
  "Punjabi",
  "Sanskrit",
  "Santali",
  "Sindhi",
  "Tamil",
  "Telugu",
  "Urdu",
  "Kokborok",
  "Mizo",
  "Khasi",
  "Garo",
  "Angika",
  "Bhojpuri",
  "Magadhi",
  "Rajasthani",
  "Marwari",
  "Mewari",
  "Shekhavati",
  "Bhili",
  "Gondi",
  "Kodava",
  "Kutchi",
  "Tulu",
  "Sankethi",
  "Mahl",
];

const astrologerTypeList = ["Consultation", "Teaching", "Pandit", "All"];

export const AddAstrologers = ({
  activeSkillsData,
  activeExpertiseData,
  activeRemediesData,
  countryData,
  countryStateData,
  stateCityData,
  countryValueData,
  isLoading,
}) => {
  var classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [galleryImage, setGalleryImage] = useState([]);
  const [galleryFiles, setGalleryFiles] = useState([]);

  const [states, setState] = useState({
    error: {},
    name: "",
    displayName: "",
    realName: "",
    email: "",
    phoneNumber: "",
    rating: "",
    currency: "",
    gender: "",
    password: "",
    dateOfBirth: "",
    experience: "",
    phoneCode: "",
    zipCode: "",
    currencyValue: "",
    language: [],
    address: "",
    country: null,
    state: "",
    city: null,
    follower_count: "",
    bankName: "",
    bankAccountNumber: "",
    accountType: "",
    ifscCode: "",
    accountHolderName: "",
    panNumber: "",
    aadharNumber: "",
    callPrice: "",
    chatPrice: "",
    skills: [],
    remedies: [],
    offers: [],
    expertise: [],
    mainExpertise: [],
    about: "",
    preferredDays: [],
    working: "No",
    educationQualification: "",
    astrologerCallPrice: "",
    companyCallPrice: "",
    astrologerChatPrice: "",
    companyChatPrice: "",
    liveVideoPrice: "",
    companyLiveVideoPrice: "",
    liveCallPrice: "",
    companyLiveCallPrice: "",

    astrologyQualification: "",
    gallery: "",
    astrologerType: [],
    countryValue: [],
  });

  const [exclusive, setExclusive] = useState("exclusive");
  const [exclusiveOne, setExclusiveOne] = useState("fifty");
  const [exclusiveTwo, setExclusiveTwo] = useState("");
  const [chatPrice, setChatPrice] = useState("");
  const [companyChatPrice, setCompanyChatPrice] = useState("");
  const [displayChatPrice, setDisplayChatPrice] = useState("");
  const [displayCallPrice, setDisplayCallPrice] = useState("");
  const [callPrice, setCallPrice] = useState("");
  const [companyCallPrice, setCompanyCallPrice] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const [profilePhoto, setprofilePhoto] = useState({
    file: logo_icon,
    bytes: "",
  });

  const [bankProof, setbankProof] = useState({
    file: logo_icon,
    bytes: "",
  });

  const [idProof, setidProof] = useState({
    file: logo_icon,
    bytes: "",
  });

  useEffect(() => {
    dispatch(SkillActions.getActiveSkillData());
    dispatch(ExpertiesActions.getActiveExpertiesData());
    dispatch(RemedyActions.getActiveRemediesData());
    dispatch(SettingActions.getCountries());
    dispatch(SettingActions.getCountryValue());
  }, []);

  const handlecurrencyValueChange = (e) => {
    const newcurrencyValue = e.target.value;
    if (isNaN(newcurrencyValue) || newcurrencyValue === "") {
      handleError("currencyValue", "Please enter a valid number");
    } else {
      const parsedcurrencyValue = parseFloat(newcurrencyValue);
      if (parsedcurrencyValue >= 0 && parsedcurrencyValue <= 5) {
        handleError("currencyValue", null);
        updateState({ currencyValue: parsedcurrencyValue });
      } else {
        handleError("currencyValue", "currencyValue must be between 0 and 5");
      }
    }
  };

  const handleSkills = (item) => {
    if (skills.some((selectedItem) => selectedItem === item._id)) {
      let skilData = skills.filter((skill) => skill !== item?._id);
      updateState({ skills: skilData });
    } else {
      updateState({ skills: [...skills, item?._id] });
    }
    handleError("skills", null);
  };

  const handleCountryValue = (item) => {
    if (countryValue.some((selectedItem) => selectedItem === item._id)) {
      let skilData = countryValue.filter(
        (countryValue) => countryValue !== item?._id
      );
      updateState({ countryValue: skilData });
    } else {
      updateState({ countryValue: [...countryValue, item?._id] });
    }
    handleError("countryValue", null);
  };

  const handleRemedies = (item) => {
    if (remedies.some((selectedItem) => selectedItem === item._id)) {
      let remedyData = remedies.filter(
        (selectedItem) => selectedItem !== item._id
      );
      updateState({ remedies: remedyData });
    } else {
      updateState({ remedies: [...remedies, item?._id] });
    }

    console.log(remedies);

    handleError("remedies", null);
  };

  const handleExpertise = (item) => {
    if (expertise.some((selectedItem) => selectedItem === item._id)) {
      const expertiesData = expertise.filter(
        (selectedItem) => selectedItem !== item._id
      );
      updateState({ expertise: expertiesData });
    } else {
      updateState({ expertise: [...expertise, item?._id] });
    }
    handleError("expertise", null);
  };

  const handlePreferredDays = (item) => {
    if (item === "All") {
      if (preferredDays.length === preferredDaysList.length - 1) {
        updateState({ preferredDays: [] });
      } else {
        updateState({
          preferredDays: preferredDaysList.filter((day) => day !== "All"),
        });
      }
    } else {
      if (preferredDays.includes(item)) {
        updateState({
          preferredDays: preferredDays.filter((day) => day !== item),
        });
      } else {
        updateState({ preferredDays: [...preferredDays, item] });
      }
    }
    handleError("preferredDays", null);
  };

  const handleAstrologerType = (item) => {
    setState((prevState) => {
      const { astrologerType } = prevState;
      if (astrologerType.includes(item)) {
        return {
          ...prevState,
          astrologerType: astrologerType.filter(
            (selectedItem) => selectedItem !== item
          ),
        };
      } else {
        return {
          ...prevState,
          astrologerType: [...astrologerType, item],
        };
      }
    });
    handleError("astrologerType", null);
  };

  // const handleProfile = (e) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     setprofilePhoto({
  //       file: URL.createObjectURL(e.target.files[0]),
  //       bytes: e.target.files[0],
  //     });
  //     handleError("profilePhoto", null);
  //   }
  // };

  // const handleCancel = () => {
  //   setprofilePhoto(null);
  //   setFileInputKey(Date.now()); // Reset file input to clear selection
  //   handleError("profilePhoto", null); // Reset any related errors
  // };

  const handleGallery = (event) => {
    const files = Array.from(event.target.files);
    const updatedGalleryImages = files.map((file) => URL.createObjectURL(file));

    // Reset the state before updating with new files
    setGalleryImage(updatedGalleryImages);
    setGalleryFiles(files);
  };

  const handleError = (field, message) => {
    setState((prev) => ({ ...prev, error: { ...prev.error, [field]: message } }));
  };

  const handleProfile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setprofilePhoto({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
      handleError("profilePhoto", null);
    }
  };

  const handleCancelProfile = () => {
    setprofilePhoto({ file: logo_icon, bytes: "" });
    handleError("profilePhoto", null);
  };

  const handlebankProof = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setbankProof({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
      handleError("bankProof", null);
    }
  };

  const handleCancelBankProof = () => {
    setbankProof({ file: logo_icon, bytes: "" });
    handleError("bankProof", null);
  };

  const handleidProof = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setidProof({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
      handleError("idProof", null);
    }
  };

  const handleCancelIdProof = () => {
    setidProof({ file: logo_icon, bytes: "" });
    handleError("idProof", null);
  };

  const handleValidation = () => {
    const newErrors = {};

    if (!displayName.trim()) newErrors.displayName = "Display Name is required";
    if (!name.trim()) newErrors.name = "Name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = "Invalid email address";
    if (!phoneNumber) newErrors.phoneNumber = "Phone Number is required";
    else if (!/^\d{10}$/.test(phoneNumber)) newErrors.phoneNumber = "Phone Number must be 10 digits";
    if (!currency) newErrors.currency = "Currency is required";
    if (!gender) newErrors.gender = "Gender is required";
    if (!password) newErrors.password = "Password is required";
    else if (password.length < 6) newErrors.password = "Password must be at least 6 characters";
    if (!dateOfBirth) newErrors.dateOfBirth = "Date of Birth is required";
    if (!experience) newErrors.experience = "Experience is required";
    if (!language || language.length === 0) newErrors.language = "At least one language is required";
    if (!address.trim()) newErrors.address = "Address is required";
    if (!country) newErrors.country = "Country is required";
    if (!states.state) newErrors.state = "State is required";
    if (!city) newErrors.city = "City is required";
    if (!zipCode) newErrors.zipCode = "Pin Code is required";
    if (!phoneCode.trim()) newErrors.phoneCode = "Country Phone Code is required";
    if (currencyValue === "" || currencyValue === null || currencyValue === undefined) newErrors.currencyValue = "Currency Value is required";
    if (follower_count === "" || follower_count === null || follower_count === undefined) newErrors.follower_count = "Follower Count is required";
    if (rating === "" || rating === null || rating === undefined) newErrors.rating = "Rating is required";
    if (!about.trim()) newErrors.about = "About is required";
    if (!preferredDays || preferredDays.length === 0) newErrors.preferredDays = "Preferred Days is required";
    if (!astrologyQualification?.trim()) newErrors.astrologyQualification = "Astrological Qualification is required";
    if (!chatPrice) newErrors.chatPrice = "Chat Price is required";
    if (!companyChatPrice) newErrors.companyChatPrice = "Company Chat Price is required";
    if (!callPrice) newErrors.callPrice = "Call Price is required";
    if (!companyCallPrice) newErrors.companyCallPrice = "Company Call Price is required";
    if (!liveVideoPrice) newErrors.liveVideoPrice = "Live Video Price is required";
    if (!companyLiveVideoPrice) newErrors.companyLiveVideoPrice = "Company Live Video Price is required";
    if (!liveCallPrice) newErrors.liveCallPrice = "Live Call Price is required";
    if (!companyLiveCallPrice) newErrors.companyLiveCallPrice = "Company Live Call Price is required";
    if (!bankAccountNumber) newErrors.bankAccountNumber = "Bank Account Number is required";
    if (!bankName.trim()) newErrors.bankName = "Bank Name is required";
    if (!accountType) newErrors.accountType = "Account Type is required";
    if (!ifscCode.trim()) newErrors.ifscCode = "IFSC Code is required";
    else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/i.test(ifscCode)) newErrors.ifscCode = "Invalid IFSC Code";
    if (!accountHolderName.trim()) newErrors.accountHolderName = "Account Holder Name is required";
    if (!panNumber.trim()) newErrors.panNumber = "PAN Number is required";
    else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(panNumber)) newErrors.panNumber = "Invalid PAN Number (e.g. ABCDE1234F)";
    if (!aadharNumber) newErrors.aadharNumber = "Aadhar Number is required";
    else if (!/^\d{12}$/.test(aadharNumber)) newErrors.aadharNumber = "Aadhar Number must be 12 digits";
    if (!profilePhoto || !profilePhoto.bytes) newErrors.profilePhoto = "Please select a Profile Picture";
    if (!bankProof || !bankProof.bytes) newErrors.bankProof = "Please select a Bank Proof";
    if (!idProof || !idProof.bytes) newErrors.idProof = "Please select an ID Proof";
    if (!galleryFiles || galleryFiles.length === 0) newErrors.gallery = "Please select gallery images";
    if (!skills || skills.length === 0) newErrors.skills = "Please select at least one skill";
    if (!remedies || remedies.length === 0) newErrors.remedies = "Please select at least one remedy";
    if (!expertise || expertise.length === 0) newErrors.expertise = "Please select at least one expertise";
    if (!astrologerType || astrologerType.length === 0) newErrors.astrologerType = "Please select at least one astrologer type";

    setState((prev) => ({ ...prev, error: newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const onAdd = () => {
    navigate("/astrologers/displayAstrologer");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!handleValidation()) return;
      let formData = new FormData();
      formData.append("displayName", displayName);
      formData.append("name", name);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("phoneNumber", phoneNumber);
      formData.append("phoneCode", phoneCode);
      formData.append("gender", gender);
      formData.append("dateOfBirth", dateOfBirth);
      formData.append("experience", experience);
      formData.append("address", address);
      formData.append("currencyType", currency);
      formData.append("currencyValue", currencyValue);
      formData.append("country", country);
      formData.append("state", state);
      formData.append("city", city);
      formData.append("zipCode", zipCode);
      formData.append("about", about);
      formData.append("educationQualification", educationQualification);
      formData.append("astrologyQualification", astrologyQualification);
      formData.append("follower_count", follower_count);
      formData.append("rating", rating);
      formData.append("bankAcountNumber", bankAccountNumber);
      formData.append("bankName", bankName);
      formData.append("accountType", accountType);
      formData.append("ifscCode", ifscCode);
      formData.append("accountHolderName", accountHolderName);
      formData.append("addharNumber", aadharNumber);
      formData.append("panNumber", panNumber);
      formData.append("chatPrice", chatPrice);
      formData.append("companyChatPrice", companyChatPrice);
      formData.append("callPrice", callPrice);
      formData.append("companyCallPrice", companyCallPrice);
      formData.append("liveVideoPrice", liveVideoPrice);
      formData.append("companyLiveVideoPrice", companyLiveVideoPrice);
      formData.append("liveCallPrice", liveCallPrice);
      formData.append("companyLiveCallPrice", companyLiveCallPrice);
      formData.append("status", "Active");
      formData.append("exclusiveType", "exclusive");
      // formData.append("working", working);
      formData.append("profileImage", profilePhoto.bytes);
      formData.append("bankProofImage", bankProof.bytes);
      formData.append("idProofImage", idProof.bytes);
      galleryFiles.forEach((imgFile) => {
        formData.append("galleryImage", imgFile);
      });

      for (let i = 0; i < countryValue.length; i++) {
        formData.append(`allowedCountryId[${i}]`, countryValue[i]);
      }
      for (let i = 0; i < preferredDays.length; i++) {
        formData.append(`preferredDays[${i}]`, preferredDays[i]);
      }
      for (let i = 0; i < astrologerType.length; i++) {
        formData.append(`astrologerType[${i}]`, astrologerType[i]);
      }
      for (let i = 0; i < language.length; i++) {
        formData.append(`language[${i}]`, language[i]);
      }
      for (let i = 0; i < skills.length; i++) {
        formData.append(`skill[${i}]`, skills[i]);
      }
      for (let i = 0; i < remedies.length; i++) {
        formData.append(`remedies[${i}]`, remedies[i]);
      }
      for (let i = 0; i < expertise.length; i++) {
        formData.append(`expertise[${i}]`, expertise[i]);
      }

      dispatch(
        AstrologerActions.addAstrologer({
          data: formData,
          reset: handleReset,
          onAdd: onAdd,
        })
      );
    } catch (e) {
      console.log("error submitting data", e);
    }
  };

  const handleReset = () => {
    updateState({
      error: {},
      name: "",
      displayName: "",
      email: "",
      phoneNumber: "",
      rating: "",
      currency: "",
      gender: "",
      password: "",
      dateOfBirth: "",
      experience: "",
      phoneCode: "",
      zipCode: "",
      currencyValue: "",
      language: [],
      address: "",
      country: "",
      state: "",
      city: "",
      follower_count: "",
      bankName: "",
      bankAccountNumber: "",
      accountType: "",
      ifscCode: "",
      accountHolderName: "",
      panNumber: "",
      aadharNumber: "",
      consultationPrice: "",
      callPrice: "",
      chatPrice: "",
      skills: [],
      remedies: [],
      expertise: [],
      mainExpertise: [],
      offers: [],
      about: "",
      preferredDays: [],
      working: "No",
      educationQualification: "",
      astrologerCallPrice: "",
      companyCallPrice: "",
      astrologerChatPrice: "",
      companyChatPrice: "",
      liveVideoPrice: "",
      companyLiveVideoPrice: "",
      liveCallPrice: "",
      companyLiveCallPrice: "",
      astrologyQualification: "",
      voicePriceLiveDollar: "",
      gallery: [],
      astrologerType: "",
      galleryImage: "",
      galleryFiles: "",
    });

    setprofilePhoto({
      file: logo_icon,
      bytes: "",
    });

    setbankProof({
      file: logo_icon,
      bytes: "",
    });

    setidProof({
      file: logo_icon,
      bytes: "",
    });
  };

  const updateState = (data) => {
    setState((prevState) => {
      const newData = { ...prevState, ...data };
      return newData;
    });
  };

  const {
    error,
    name,
    displayName,
    email,
    phoneNumber,
    rating,
    currency,
    gender,
    password,
    dateOfBirth,
    experience,
    phoneCode,
    zipCode,
    currencyValue,
    language,
    country,
    state,
    city,
    follower_count,
    bankName,
    bankAccountNumber,
    ifscCode,
    accountHolderName,
    accountType,
    aadharNumber,
    about,
    address,
    working,
    panNumber,
    preferredDays,
    skills,
    expertise,
    remedies,
    // callPrice,
    // companyCallPrice,
    // chatPrice,
    // displayChatPrice,
    educationQualification,
    indiaDisplayPrice,
    astrologerCallPrice,
    astrologerChatPrice,
    // companyChatPrice,
    liveVideoPrice,
    companyLiveVideoPrice,
    liveCallPrice,
    companyLiveCallPrice,
    astrologyQualification,
    gallery,
    astrologerType,
    countryValue,
  } = states;

  const get_date_value = () => {
    var currentDate = new Date();

    // Subtract 16 years from the current date
    var previous16YearsDate = new Date(currentDate);
    previous16YearsDate.setFullYear(currentDate.getFullYear() - 16);

    // Format the date as yyyy-mm-dd
    var formattedDate = previous16YearsDate.toISOString().split("T")[0];
    return formattedDate;
  };

  useEffect(() => {
    if (country) {
      dispatch(SettingActions.countryStateList({ countryId: country }));
    }
  }, [country]);

  useEffect(() => {
    if (state) {
      dispatch(SettingActions.stateCityList({ stateId: state }));
    }
  }, [state]);

  const callPriceInt = parseFloat(callPrice);
  const companyCallPriceInt = parseFloat(companyCallPrice);

  const chatPriceInt = parseFloat(chatPrice);
  const companyChatPriceInt = parseFloat(companyChatPrice);

  const liveVideoPriceInt = parseFloat(liveVideoPrice);
  const companyLiveVideoPriceInt = parseFloat(companyLiveVideoPrice);

  const liveCallPriceInt = parseFloat(liveCallPrice);
  const companyLiveCallPriceInt = parseFloat(companyLiveCallPrice);

  const handleChange = (name, value) => {
    switch (name) {
      case "exclusive":
        setExclusive(value);
        setExclusiveOne(""); // Reset exclusiveOne when exclusive changes
        setExclusiveTwo(""); // Reset exclusiveTwo when exclusive changes
        setChatPrice("");
        setCompanyChatPrice("");
        setCallPrice("");
        setCompanyCallPrice("");
        break;
      case "exclusiveOne":
        setExclusiveOne(value);
        calculatePrices(value, displayChatPrice, "exclusive");
        // Update call prices based on the current displayCallPrice
        calculatePrices(value, displayCallPrice, "exclusive", true);
        break;
      case "exclusiveTwo":
        setExclusiveTwo(value);
        calculatePrices(value, displayChatPrice, "nonExclusive");
        // Update call prices based on the current displayCallPrice
        calculatePrices(value, displayCallPrice, "nonExclusive", true);
        break;
      case "displayChatPrice":
        setDisplayChatPrice(value);
        // Calculate prices for both exclusive and non-exclusive selections
        calculatePrices(exclusiveOne, value, "exclusive");
        calculatePrices(exclusiveTwo, value, "nonExclusive");
        break;
      case "displayCallPrice":
        setDisplayCallPrice(value);
        // Calculate prices for both exclusive and non-exclusive selections
        calculatePrices(exclusiveOne, value, "exclusive", true);
        calculatePrices(exclusiveTwo, value, "nonExclusive", true);
        break;
      default:
        break;
    }
  };

  const calculatePrices = (
    selection,
    displayPrice,
    type,
    isCallPrice = false
  ) => {
    const displayValue = parseFloat(displayPrice);
    if (!isNaN(displayValue) && selection) {
      let percentage;

      if (type === "exclusive") {
        percentage =
          selection === "fifty"
            ? 0.5
            : selection === "fiftyFive"
            ? 0.55
            : undefined; // Adjusted for fiftyFive
      } else if (type === "nonExclusive") {
        percentage =
          selection === "fourty"
            ? 0.4
            : selection === "fortyFive"
            ? 0.45
            : undefined; // Adjusted for fortyFive
      }

      if (percentage !== undefined) {
        if (isCallPrice) {
          // Update call prices
          setCallPrice((displayValue * percentage).toFixed(2));
          setCompanyCallPrice((displayValue * (1 - percentage)).toFixed(2));
        } else {
          // Update chat prices
          setChatPrice((displayValue * percentage).toFixed(2));
          setCompanyChatPrice((displayValue * (1 - percentage)).toFixed(2));
        }
      }
    }
  };

  return (
    <>
      {/* <Loader isLoading={isLoading}/> */}

      <div className={classes.container}>
        <div className={classes.box}>
          <Grid container spacing={2}>
            {/* {astrologerInputsInfo()} */}
            <Grid item lg={12} sm={12} md={12} xs={12}>
              <div className={classes.headingContainer}>
                <div className={classes.heading}>Add Astrologer</div>
              </div>
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Display Name"
                value={displayName}
                variant="outlined"
                fullWidth
                error={!!error.displayName ? true : false}
                onFocus={() => handleError("display name", null)}
                onChange={(e) => updateState({ displayName: e.target.value })}
                helperText={error.displayName}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Name"
                value={name}
                variant="outlined"
                fullWidth
                error={!!error.name ? true : false}
                onFocus={() => handleError("real name", null)}
                onChange={(e) => updateState({ name: e.target.value })}
                helperText={error.name}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Enter Email"
                value={email}
                variant="outlined"
                fullWidth
                error={!!error.email ? true : false}
                onFocus={() => handleError("email", null)}
                onChange={(e) => updateState({ email: e.target.value })}
                helperText={error.email}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Enter Phone Number"
                value={phoneNumber}
                variant="outlined"
                fullWidth
                type="number"
                helperText={error.phoneNumber}
                error={error.phoneNumber ? true : false}
                onFocus={() => handleError("phoneNumber", null)}
                onChange={(e) => updateState({ phoneNumber: e.target.value })}
              />
            </Grid>

            <Grid item lg={4} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Currency</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="currency"
                  value={currency}
                  error={error.currency ? true : false}
                  onFocus={() => handleError("currency", null)}
                  onChange={(e) => updateState({ currency: e.target.value })}>
                  <MenuItem disabled value={null}>
                    -Select Currency-
                  </MenuItem>
                  <MenuItem value="INR">INR</MenuItem>
                  <MenuItem value="USD">USD</MenuItem>
                </Select>
                {error.currency && (
                  <div className={classes.errorstyles}>{error.currency}</div>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="gender"
                  value={gender}
                  error={error.gender ? true : false}
                  onFocus={() => handleError("gender", null)}
                  onChange={(e) => updateState({ gender: e.target.value })}>
                  <MenuItem disabled value={null}>
                    -Select Gender-
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
                {error.gender && (
                  <div className={classes.errorstyles}>{error.gender}</div>
                )}
              </FormControl>
            </Grid>
            {/* <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Password"
                type="password"
                value={password}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("password", null)}
                onChange={(e) => updateState({ password: e.target.value })}
                helperText={error.password}
                error={error.password ? true : false}
              />
            </Grid> */}
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("password", null)}
                onChange={(e) => updateState({ password: e.target.value })}
                helperText={error.password}
                error={!!error.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleShowPassword} edge="end">
                        {/* {showPassword ? <VisibilityOff /> : <Visibility />} */}
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="date"
                value={dateOfBirth}
                variant="outlined"
                // inputProps={{ max: "2020-05-31" }}
                inputProps={{
                  max: get_date_value(),
                }}
                fullWidth
                onFocus={() => handleError("dateOfBirth", null)}
                onChange={(e) => updateState({ dateOfBirth: e.target.value })}
                helperText={error.dateOfBirth}
                error={error.dateOfBirth ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Experience"
                type="number"
                value={experience}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("experience", null)}
                onChange={(e) => updateState({ experience: e.target.value })}
                helperText={error.experience}
                error={error.experience ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-multiple-checkbox-label">
                  Language
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={language}
                  onChange={(e) => updateState({ language: e.target.value })}
                  onFocus={() => handleError("language", null)}
                  renderValue={(selected) => selected.join(", ")}
                  error={!!error.language}>
                  <MenuItem disabled value="">
                    -Select Language-
                  </MenuItem>
                  {languages.map((item) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox checked={language.indexOf(item) > -1} />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
                {error.language && (
                  <div className={classes.errorstyles}>{error.language}</div>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Address"
                value={address}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("address", null)}
                onChange={(e) => updateState({ address: e.target.value })}
                helperText={error.address}
                error={error.address ? true : false}
              />
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Country</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Country"
                  value={country}
                  onFocus={(e) => handleError("country", null)}
                  onChange={(e) => updateState({ country: e.target.value })}
                  error={error.country ? true : false}>
                  <MenuItem disabled value={null}>
                    -Select your Country-
                  </MenuItem>
                  {countryData?.map((item) => (
                    <MenuItem key={item.id} value={item._id}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
                {error.country && (
                  <div className={classes.errorstyles}>{error.country}</div>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="state-select-label">State</InputLabel>
                <Select
                  labelId="state-select-label"
                  id="state-select"
                  value={states.state}
                  onFocus={() =>
                    setState((prevState) => ({
                      ...prevState,
                      error: { ...prevState.error, state: null },
                    }))
                  }
                  onChange={(e) => updateState({ state: e.target.value })}
                  error={!!states.error.state}
                  disabled={!states.country}>
                  <MenuItem disabled value="">
                    -Select your State-
                  </MenuItem>
                  {countryStateData &&
                    countryStateData.length > 0 &&
                    countryStateData?.map((item) => (
                      <MenuItem key={item.id} value={item._id}>
                        {item.title}
                      </MenuItem>
                    ))}
                </Select>
                {states.error.state && (
                  <div className={classes.errorstyles}>
                    {states.error.state}
                  </div>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">City</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="City"
                  value={city}
                  onFocus={() => handleError("city", null)}
                  onChange={(e) => updateState({ city: e.target.value })}
                  error={error.city ? true : false}
                  disabled={!states.state}>
                  <MenuItem disabled value={null}>
                    -Select your City-
                  </MenuItem>
                  {stateCityData &&
                    stateCityData.length > 0 &&
                    stateCityData?.map((item) => (
                      <MenuItem key={item.id} value={item._id}>
                        {item.title}
                      </MenuItem>
                    ))}
                </Select>
                {error.city && (
                  <div className={classes.errorstyles}>{error.city}</div>
                )}
              </FormControl>
            </Grid>

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Pin Code"
                value={zipCode}
                variant="outlined"
                type="number"
                fullWidth
                onFocus={() => handleError("zipCode", null)}
                onChange={(e) => updateState({ zipCode: e.target.value })}
                helperText={error.zipCode}
                error={error.zipCode ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Country Phone Code"
                value={phoneCode}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("phoneCode", null)}
                onChange={(e) => updateState({ phoneCode: e.target.value })}
                helperText={error.phoneCode}
                error={error.phoneCode ? true : false}
              />
            </Grid>

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Currency Value"
                value={currencyValue}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("currencyValue", null)}
                onChange={handlecurrencyValueChange}
                helperText={error.currencyValue}
                error={error.currencyValue ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Followers Count"
                value={follower_count}
                variant="outlined"
                type="number"
                fullWidth
                onChange={(e) =>
                  updateState({ follower_count: e.target.value })
                }
                helperText={error.follower_count}
                error={error.follower_count ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Rating"
                value={rating}
                variant="outlined"
                type="number"
                fullWidth
                helperText={error.rating}
                error={error.rating ? true : false}
                onFocus={() => handleError("rating", null)}
                onChange={(e) => updateState({ rating: e.target.value })}
                inputProps={{
                  min: 0,
                  max: 5,
                }}
              />
            </Grid>
            {/* astrologer container ends here */}

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Preferred Days</FormLabel>
                <FormGroup aria-label="position" row>
                  {preferredDaysList.map((item) => (
                    <div key={item} className={classes.chips}>
                      <FormControlLabel
                        value={item}
                        className={classes.checkbox}
                        control={
                          <Checkbox
                            checked={
                              item === "All"
                                ? preferredDays.length ===
                                  preferredDaysList.length - 1
                                : preferredDays.includes(item)
                            }
                            onChange={() => handlePreferredDays(item)}
                          />
                        }
                        label={item}
                        labelPlacement="end"
                      />
                    </div>
                  ))}
                </FormGroup>
              </FormControl>
              {error.preferredDays && (
                <div className={classes.errorstyles}>{error.preferredDays}</div>
              )}
            </Grid>

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  style={{
                    fontFamily: "Philospher",
                    color: Colors.black,
                    fontSize: "1.2rem",
                  }}>
                  Are you working on any other online portal?
                </FormLabel>
                <RadioGroup
                  row
                  aria-label="position"
                  name="position"
                  defaultValue={working}
                  onChange={(e) => updateState({ working: e.target.value })}>
                  <FormControlLabel
                    value={"No"}
                    control={<Radio color="primary" />}
                    label="No"
                  />
                  <FormControlLabel
                    value={"Yes"}
                    control={<Radio color="primary" />}
                    label="Yes"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {/* days & working */}

            <Grid item lg={12} sm={12} md={12} xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Available Countries</FormLabel>
                <FormGroup aria-label="position" row>
                  {countryValueData &&
                    countryValueData.map((item) => {
                      return (
                        <div className={classes.chips}>
                          <FormControlLabel
                            value={item.title}
                            className={classes.checkbox}
                            control={
                              <Checkbox
                                checked={
                                  countryValue &&
                                  countryValue.includes(item._id)
                                }
                                onChange={() => handleCountryValue(item)}
                              />
                            }
                            label={item.title + " " + item.countryValue + "X"}
                            labelPlacement="end"
                          />
                        </div>
                      );
                    })}
                </FormGroup>
              </FormControl>
              {error.countryValue && (
                <div className={classes.errorstyles}>{error.countryValue}</div>
              )}
            </Grid>

            <Grid item lg={6} sm={12} md={12} xs={12}>
              <TextField
                type="text"
                label="Educational Qualification"
                value={educationQualification}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  updateState({ educationQualification: e.target.value })
                }
                helperText={error.educationQualification}
                error={error.educationQualification ? true : false}
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12} xs={12}>
              <TextField
                type="text"
                label="Astrological Qualification"
                value={astrologyQualification}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  updateState({ astrologyQualification: e.target.value })
                }
                helperText={error.astrologyQualification}
                error={error.astrologyQualification ? true : false}
              />
            </Grid>

            <Grid item lg={4} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={exclusive}
                  error={!!error.exclusive}
                  onFocus={() => handleError("exclusive", null)}
                  onChange={(e) => handleChange("exclusive", e.target.value)}>
                  <MenuItem disabled value="">
                    -Select Option-
                  </MenuItem>
                  <MenuItem value="exclusive">Exclusive</MenuItem>
                  <MenuItem value="nonExclusive">Non Exclusive</MenuItem>
                </Select>
                {error.exclusive && (
                  <div className={classes.errorstyles}>{error.exclusive}</div>
                )}
              </FormControl>
            </Grid>

            {exclusive === "exclusive" && (
              <Grid item lg={4} md={12} sm={12} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="exclusive-one-label">Exclusive</InputLabel>
                  <Select
                    labelId="exclusive-one-label"
                    id="exclusive-one-select"
                    value={exclusiveOne}
                    error={!!error.exclusiveOne}
                    onFocus={() => handleError("exclusiveOne", null)}
                    onChange={(e) =>
                      handleChange("exclusiveOne", e.target.value)
                    }>
                    <MenuItem disabled value="">
                      -Select Option-
                    </MenuItem>
                    <MenuItem value="fifty">50</MenuItem>
                    <MenuItem value="fiftyFive">55</MenuItem>
                  </Select>
                  {error.exclusiveOne && (
                    <div className={classes.errorstyles}>
                      {error.exclusiveOne}
                    </div>
                  )}
                </FormControl>
              </Grid>
            )}

            {exclusive === "nonExclusive" && (
              <Grid item lg={4} md={12} sm={12} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="exclusive-two-label">
                    Non-Exclusive
                  </InputLabel>
                  <Select
                    labelId="exclusive-two-label"
                    id="exclusive-two-select"
                    value={exclusiveTwo}
                    error={!!error.exclusiveTwo}
                    onFocus={() => handleError("exclusiveTwo", null)}
                    onChange={(e) =>
                      handleChange("exclusiveTwo", e.target.value)
                    }>
                    <MenuItem disabled value="">
                      -Select Option-
                    </MenuItem>
                    <MenuItem value="fourty">40</MenuItem>
                    <MenuItem value="fourtyFive">45</MenuItem>
                  </Select>
                  {error.exclusiveTwo && (
                    <div className={classes.errorstyles}>
                      {error.exclusiveTwo}
                    </div>
                  )}
                </FormControl>
              </Grid>
            )}

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                fullWidth
                label="Display Chat Price"
                value={displayChatPrice}
                onChange={(e) =>
                  handleChange("displayChatPrice", e.target.value)
                }
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Chat Price"
                inputMode="numeric"
                value={chatPrice}
                variant="outlined"
                fullWidth
                onChange={(e) => setChatPrice(e.target.value)} // Optional, could be readonly
                helperText={error.chatPrice}
                error={!!error.chatPrice}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Company Chat Price"
                inputMode="numeric"
                value={companyChatPrice}
                variant="outlined"
                fullWidth
                onChange={(e) => setCompanyChatPrice(e.target.value)} // Optional, could be readonly
                helperText={error.companyChatPrice}
                error={!!error.companyChatPrice}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                fullWidth
                label="Display Call Price"
                value={displayCallPrice}
                onChange={(e) =>
                  handleChange("displayCallPrice", e.target.value)
                }
              />
            </Grid>

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Call Price"
                inputMode="numeric"
                value={callPrice}
                variant="outlined"
                fullWidth
                onChange={(e) => updateState({ callPrice: e.target.value })}
                helperText={error.callPrice}
                error={error.callPrice ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Company Call Price"
                inputMode="numeric"
                value={companyCallPrice}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  updateState({ companyCallPrice: e.target.value })
                }
                helperText={error.companyCallPrice}
                error={error.companyCallPrice ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Live Video Price"
                inputMode="numeric"
                value={liveVideoPrice}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  updateState({ liveVideoPrice: e.target.value })
                }
                helperText={error.liveVideoPrice}
                error={error.liveVideoPrice ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Company Live Video Price"
                inputMode="numeric"
                value={companyLiveVideoPrice}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  updateState({ companyLiveVideoPrice: e.target.value })
                }
                helperText={error.companyLiveVideoPrice}
                error={error.companyLiveVideoPrice ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Live Call Price"
                inputMode="numeric"
                value={liveCallPrice}
                variant="outlined"
                fullWidth
                onChange={(e) => updateState({ liveCallPrice: e.target.value })}
                helperText={error.liveCallPrice}
                error={error.liveCallPrice ? true : false}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Company Live Call Price"
                inputMode="numeric"
                value={companyLiveCallPrice}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  updateState({ companyLiveCallPrice: e.target.value })
                }
                helperText={error.companyLiveCallPrice}
                error={error.companyLiveCallPrice ? true : false}
              />
            </Grid>

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                fullWidth
                label="Display Live Video Price"
                value={liveVideoPriceInt + companyLiveVideoPriceInt}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                fullWidth
                label="Display Live Call Price"
                value={liveCallPriceInt + companyLiveCallPriceInt}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>

            <Grid
              item
              lg={6}
              sm={12}
              md={12}
              xs={12}
              className={classes.uploadContainer}>
              <Grid component="label" className={classes.uploadImageButton}>
                Upload Gallery Images
                <input
                  onChange={handleGallery}
                  hidden
                  accept="image/*"
                  type="file"
                  multiple
                />
              </Grid>

              <div className={classes.errorStyle}>{error.gallery}</div>
            </Grid>

            <Grid item lg={6} sm={12} md={6} xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Astrologer Type</FormLabel>
                <FormGroup aria-label="position" row>
                  {astrologerTypeList &&
                    astrologerTypeList.map((item) => (
                      <div className={classes.chips} key={item}>
                        <FormControlLabel
                          value={item}
                          className={classes.checkbox}
                          control={
                            <Checkbox
                              checked={states.astrologerType.includes(item)}
                              onChange={() => handleAstrologerType(item)}
                            />
                          }
                          label={item}
                          labelPlacement="end"
                        />
                      </div>
                    ))}
                </FormGroup>
              </FormControl>
              {error.astrologerType && (
                <div className={classes.errorstyles}>
                  {error.astrologerType}
                </div>
              )}
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12}>
              {/* <Typography variant="h6" component="label">Gallery Image</Typography>  */}
              <Grid
                container
                direction="row"
                spacing={2}
                style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                {galleryImage.map((imgSrc, index) => (
                  <Grid item key={index} style={{ width: "auto" }}>
                    <Avatar
                      src={imgSrc}
                      variant="square"
                      style={{ width: "100px", height: "100px" }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12}>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                label="About"
                value={about}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("about", null)}
                onChange={(e) => updateState({ about: e.target.value })}
                helperText={error.about}
                error={error.about ? true : false}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12} xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Skills</FormLabel>
                <FormGroup aria-label="position" row>
                  {activeSkillsData &&
                    activeSkillsData.map((item) => {
                      return (
                        <div className={classes.chips}>
                          <FormControlLabel
                            value={item.title}
                            className={classes.checkbox}
                            control={
                              <Checkbox
                                checked={skills && skills.includes(item._id)}
                                onChange={() => handleSkills(item)}
                              />
                            }
                            label={item.title}
                            labelPlacement="end"
                          />
                        </div>
                      );
                    })}
                </FormGroup>
              </FormControl>
              {error.skills && (
                <div className={classes.errorstyles}>{error.skills}</div>
              )}
            </Grid>
            <Grid item lg={6} sm={12} md={12} xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Remedies</FormLabel>
                <FormGroup aria-label="position" row>
                  {activeRemediesData &&
                    activeRemediesData.map((item) => {
                      return (
                        <div key={item._id} className={classes.chips}>
                          <FormControlLabel
                            className={classes.checkbox}
                            control={
                              <Checkbox
                                checked={
                                  remedies && remedies.includes(item._id)
                                }
                                onChange={() => handleRemedies(item)}
                              />
                            }
                            label={item.title}
                            labelPlacement="end"
                          />
                        </div>
                      );
                    })}
                </FormGroup>
              </FormControl>
              {error.remedies && (
                <div className={classes.errorstyles}>{error.remedies}</div>
              )}
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Expertise</FormLabel>
                <FormGroup aria-label="position" row>
                  {activeExpertiseData &&
                    activeExpertiseData.map((item) => {
                      return (
                        <div className={classes.chips}>
                          <FormControlLabel
                            value={item.title}
                            className={classes.checkbox}
                            control={
                              <Checkbox
                                checked={
                                  expertise && expertise.includes(item._id)
                                }
                                onChange={() => handleExpertise(item)}
                              />
                            }
                            label={item.title}
                            labelPlacement="end"
                          />
                        </div>
                      );
                    })}
                </FormGroup>
              </FormControl>
              {error.expertise && (
                <div className={classes.errorstyles}>{error.expertise}</div>
              )}
            </Grid>

            {/* Profile Photo Upload Section */}
            <Grid
              item
              lg={3}
              sm={3}
              md={3}
              xs={3}
              className={classes.uploadContainer}>
              <Grid
                component="label"
                onClick={handleProfile}
                className={classes.uploadImageButton}>
                Upload Profile Photo
                <input
                  onChange={handleProfile}
                  hidden
                  accept="image/*"
                  type="file"
                />
              </Grid>
              <div className={classes.errorstyles}>
                {error.profilePhoto}
              </div>
            </Grid>
            <Grid item lg={1} sm={1} md={1} xs={1}>
              <div style={{ position: "relative" }}>
                <Avatar
                  color={Colors.primaryDark}
                  src={profilePhoto ? profilePhoto.file : null}
                  style={{ width: 56, height: 56 }}
                />
                {profilePhoto && (
                  <IconButton
                    onClick={handleCancelProfile}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      backgroundColor: "white", // Optional: for better visibility
                    }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </Grid>

            {/* Bank Proof Upload Section */}
            <Grid
              item
              lg={3}
              sm={3}
              md={3}
              xs={3}
              className={classes.uploadContainer}>
              <Grid
                component="label"
                onClick={handlebankProof}
                className={classes.uploadImageButton}>
                Upload Bank Proof
                <input
                  onChange={handlebankProof}
                  hidden
                  accept="image/*"
                  type="file"
                />
              </Grid>
              <div className={classes.errorstyles}>{error.bankProof}</div>
            </Grid>
            <Grid item lg={1} sm={1} md={1} xs={1}>
              <div style={{ position: "relative" }}>
                <Avatar
                  color={Colors.primaryDark}
                  src={bankProof ? bankProof.file : null}
                  style={{ width: 56, height: 56 }}
                />
                {bankProof && (
                  <IconButton
                    onClick={handleCancelBankProof}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      backgroundColor: "white", // Optional: for better visibility
                    }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </Grid>

            {/* ID Proof Upload Section */}
            <Grid
              item
              lg={3}
              sm={3}
              md={3}
              xs={3}
              className={classes.uploadContainer}>
              <Grid
                component="label"
                onClick={handleidProof}
                className={classes.uploadImageButton}>
                Upload ID Proof
                <input
                  onChange={handleidProof}
                  hidden
                  accept="image/*"
                  type="file"
                />
              </Grid>
              <div className={classes.errorstyles}>{error.idProof}</div>
            </Grid>
            <Grid item lg={1} sm={1} md={1} xs={1}>
              <div style={{ position: "relative" }}>
                <Avatar
                  color={Colors.primaryDark}
                  src={idProof ? idProof.file : null}
                  style={{ width: 56, height: 56 }}
                />
                {idProof && (
                  <IconButton
                    onClick={handleCancelIdProof}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      backgroundColor: "white", // Optional: for better visibility
                    }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </Grid>

            <Grid item lg={3} sm={12} md={12} xs={12}>
              <TextField
                label="Bank Account Number"
                value={bankAccountNumber}
                variant="outlined"
                fullWidth
                type="number"
                onFocus={() => handleError("bankAccountNumber", null)}
                onChange={(e) =>
                  updateState({ bankAccountNumber: e.target.value })
                }
                helperText={error.bankAccountNumber}
                error={error.bankAccountNumber ? true : false}
              />
            </Grid>
            <Grid item lg={3} sm={12} md={12} xs={12}>
              <TextField
                label="Enter Bank Name"
                value={bankName}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("bankName", null)}
                onChange={(e) => updateState({ bankName: e.target.value })}
                helperText={error.bankName}
                error={!!error.bankName}
              />
            </Grid>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Account Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Account Type"
                  value={accountType}
                  onFocus={() => handleError("accountType", null)}
                  onChange={(e) => updateState({ accountType: e.target.value })}
                  helperText={error.accountType}
                  error={error.accountType ? true : false}>
                  <div className={classes.errorstyles}>{error.accountType}</div>
                  <MenuItem disabled value={null}>
                    -Select Account type-
                  </MenuItem>
                  <MenuItem value="saving">Saving</MenuItem>
                  <MenuItem value="current">Current</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={3} sm={12} md={12} xs={12}>
              <TextField
                label="Enter IFSC Code"
                value={ifscCode}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("ifscCode", null)}
                onChange={(e) => updateState({ ifscCode: e.target.value })}
                helperText={error.ifscCode}
                error={!!error.ifscCode}
              />
            </Grid>

            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="Account Holder Name"
                value={accountHolderName}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("accountHolderName", null)}
                onChange={(e) =>
                  updateState({ accountHolderName: e.target.value })
                }
                helperText={error.accountHolderName}
                error={!!error.accountHolderName}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                label="PAN card Number"
                value={panNumber}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("panNumber", null)}
                onChange={(e) => updateState({ panNumber: e.target.value })}
                helperText={error.panNumber}
                error={!!error.panNumber}
              />
            </Grid>
            <Grid item lg={4} sm={12} md={12} xs={12}>
              <TextField
                type="number"
                label="Adhar card Number"
                inputMode="numeric"
                value={aadharNumber}
                variant="outlined"
                fullWidth
                onFocus={() => handleError("aadharNumber", null)}
                onChange={(e) => updateState({ aadharNumber: e.target.value })}
                helperText={error.aadharNumber}
                error={!!error.aadharNumber}
              />
            </Grid>
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <div onClick={handleSubmit} className={classes.submitbutton}>
                {isLoading ? <CircularProgress size={24} /> : " Submit"}
              </div>
            </Grid>
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <div className={classes.denyButton} onClick={() => handleReset()}>
                Reset
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  activeSkillsData: state.skills.activeSkillsData,
  activeExpertiseData: state.experites.activeExpertiseData,
  activeRemediesData: state.remedies.activeRemediesData,
  countryData: state.setting.countryData,
  countryStateData: state.setting.countryStateData,
  stateCityData: state.setting.stateCityData,
  countryValueData: state.setting.countryValueData,
  isLoading: state.astrologer.isLoading,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(AddAstrologers);
